<template>
  <div class="flex justify-between items-center">
    <h2 class="text-size-h2 font-semibold">{{ title }}</h2>

    <div
      v-if="navigation"
      class="navigation flex items-center gap-3 max-md:hidden"
    >
      <UButton
        class="text-button-secondary-foreground"
        icon="i-local-chevron-left"
        variant="outline"
        @click="emit('prev')"
      />

      <div class="font-lato! text-size-md text-neutral-default">
        {{ current }}
      </div>

      <UButton
        icon="i-local-chevron-right"
        variant="outline"
        @click="emit('next')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'SPGallerySectionHeader',
})

withDefaults(
  defineProps<{
    title?: string
    navigation?: boolean
    current: string
    total: number
    perView: number
    isStart?: boolean
    isEnd?: boolean
  }>(),
  {
    title: 'Галерея',
    navigation: true,
  },
)

const emit = defineEmits<{
  prev: []
  next: []
}>()
</script>

<style lang="scss" scoped></style>
